function addIndictatorElement(){
    // get the nav bounding rect
    const nav = document.getElementById('desktop-nav');
    const navRect = nav.getBoundingClientRect();

    // create an indicator element and absolute position it
    const indicator = document.createElement('div');
    indicator.classList.add('menu-indicator');
    Object.assign(indicator.style, {
        position: 'fixed',
        top: (navRect.bottom - 3) + 'px',
        left: navRect.left + 'px',
        width: '0px',
        height: '4px',
        backgroundColor: '#00BA8D',
        zIndex: 9999,
        transition: 'all 0.3s ease-in-out',
    });

    // append the indicator to the body
    document.body.appendChild(indicator);
}

export function indicatorInit(){

    addIndictatorElement();

    var indicator = document.querySelector('.menu-indicator');

    // get all #desktop-nav .menu-item elements
    const menuItems = document.querySelectorAll('#desktop-nav .menu-item');

    // loop through each menu item
    menuItems.forEach(item => {
        // add a hover event listener
        item.addEventListener('mouseover', () => {
            // get the width of the target menu item
            const width = item.getBoundingClientRect().width;

            // set the indicator width to the width of the target menu item
            indicator.style.width = width + 'px';

            // set the left position of the indicator to the left position of the target menu item
            indicator.style.left = item.getBoundingClientRect().left + 'px';
        });
    });

    // add a mouseleave event listener to the nav element that sets the indicator width to 0px
    // mouseleave will not trigger when moving between child elements of the nav
    const nav = document.getElementById('desktop-nav');
    nav.addEventListener('mouseleave', () => {
        indicator.style.width = '0px';
    });

    // if the window is resized reduce the width of the indicator to 0px
    window.addEventListener('resize', () => {
        indicator.style.width = '0px';
    });

}
